import { Box, Typography } from "@mui/material";

/**
 * Entry contribution tooltip - shows threshold and performance for hosts
 * @param {Object} props
 * @param {string} props.label - Brand name
 * @param {number} props.value - Entry count
 * @param {number} props.percentage - Percentage of total
 * @param {Object} props.item - Full data item with threshold
 * @returns {import("react").ReactElement}
 */
export default function EntryContributionTooltip(props) {
  const { label, value, percentage, item } = props;
  const threshold = item.threshold || 0;
  const performance = threshold > 0 ? ((value / threshold) * 100).toFixed(2) : 0;

  if (threshold > 0) {
    return (
      <Box sx={{ p: 0.5, minWidth: 140 }}>
        <Typography sx={{ mb: 0.5 }}>Assigned Threshold:</Typography>
        <Typography sx={{ fontWeight: 700, mb: 1 }}>{threshold.toLocaleString()}</Typography>
        <Typography sx={{ mb: 0.5 }}>Performance:</Typography>
        <Typography sx={{ fontWeight: 700 }}>{performance}%</Typography>
      </Box>
    );
  }

  // Default tooltip for non-host or no threshold
  return (
    <Box sx={{ p: 0.5 }}>
      <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
      <Typography>
        {value?.toLocaleString()} entries ({percentage}%)
      </Typography>
    </Box>
  );
}
